'use strict';

/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/get-proto/Reflect.getPrototypeOf.js
// module id = 1848
// module chunks = 0